// src/components/SEOHead.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE = 'https://edutechpulselab.com';

export default function SEOHead({ 
  title = "Edutech Pulse Lab - Laboratorio de IA Educativa",
  description = "Entrena con simuladores IA, domina metodologías ágiles y desarrolla liderazgo tecnológico. Donde la inteligencia artificial potencia tu crecimiento profesional.",
  keywords = "inteligencia artificial, simuladores IA, metodologías ágiles, liderazgo ejecutivo, pensamiento tecnológico, entrenamiento profesional, innovación humana, laboratorio educativo, educación tecnológica, capacitación empresarial, desarrollo profesional, coaching ejecutivo, gestión ágil, SCRUM, Design Thinking, Lean Startup, transformación digital, habilidades directivas, simulación empresarial, AI training, machine learning educativo, competencias digitales, liderazgo tecnológico",
  url = BASE,
  image = `${BASE}/isotipoedutech.png`,
  canonicalUrl = null,
  ogType = "website",
  schema = null,
  robots = "index, follow"
}) {
  const location = useLocation();
  // Canonical: prop explícita > ruta actual (nunca homepage como fallback)
  const resolvedCanonical = canonicalUrl
    ? `${BASE}${canonicalUrl}`
    : `${BASE}${location.pathname}`;

  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta tags
    const updateMeta = (name, content, property = false) => {
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector);
      
      if (!meta) {
        meta = document.createElement('meta');
        if (property) {
          meta.setAttribute('property', name);
        } else {
          meta.setAttribute('name', name);
        }
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    // Basic meta tags
    updateMeta('description', description);
    
    // Robots meta (SEO control)
    updateMeta('robots', robots);
    updateMeta('googlebot', robots);
    
    // Open Graph tags
    updateMeta('og:title', title, true);
    updateMeta('og:description', description, true);
    updateMeta('og:image', image, true);
    updateMeta('og:type', ogType, true);
    
    // Twitter Card tags
    updateMeta('twitter:title', title);
    updateMeta('twitter:description', description);
    updateMeta('twitter:image', image);
    updateMeta('twitter:card', 'summary_large_image');
    
    // WhatsApp specific
    updateMeta('og:image:secure_url', image, true);
    updateMeta('og:rich_attachment', 'true', true);
    
    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', resolvedCanonical);

    // Sync og:url with canonical (no www, always canonical)
    updateMeta('og:url', resolvedCanonical, true);
    
    // Inject JSON-LD schema if provided (remove stale schema on page navigation)
    if (schema) {
      let scriptTag = document.querySelector('script[type="application/ld+json"]');
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(schema);
    } else {
      const staleScript = document.querySelector('script[type="application/ld+json"]');
      if (staleScript) staleScript.remove();
    }
    
  }, [title, description, keywords, url, image, canonicalUrl, ogType, schema, robots, resolvedCanonical]);

  return null; // This component doesn't render anything
}